module.exports = __webpack_public_path__ + "img/Badge_SILVER.2d080838.png";